$(window).on('load', function () {
    if ($('.js-article-header-video').length) {
        $('.js-article-header-video').each(function () {
            let videoIframe = "<iframe class='c-article-header-media__iframe' allow='fullscreen' allowfullscreen src='https://www.youtube.com/embed/"+$(this).attr('data-videoid')+"'><iframe/>"
            $(this).html(videoIframe);
        });
    }
});